import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import API from '../api/API';
import TokenService from '../api/tokenService';
import './login.css';
import Header from '../components/menu/header';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();
  
  // Controlla se l'utente è già loggato al caricamento del componente
  useEffect(() => {
    if (TokenService.isValidToken()) {
      navigate('/admin');
    }
  }, [navigate]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      // Hash password with MD5 before sending
      const hashedPassword =  CryptoJS.MD5(password).toString();
      
      const response = await API.auth.login({
        username: username,
        password: hashedPassword
      });
      
      console.log(response);
      
      if (response.isSuccess && response.data) {
        // Store token nel servizio esistente
        TokenService.setToken(response.data.token);
        
        // Redirect to admin page
        navigate('/admin');
      } else {
        setError('Login fallito. Controlla username e password.');
      }
    } catch (error) {
      setError('Errore durante il login. Riprova più tardi.');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="login-page">
      <Header />
      <div className="login-container">
        <div className="login-form-container">
          <h1>ScoutballItalia</h1>
          <form onSubmit={handleSubmit} className="login-form">
            <div className="login-form-group">
              <label htmlFor="username">
                <i className="fas fa-user"></i>
                Username
              </label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Inserisci il tuo username"
                required
                disabled={loading}
              />
            </div>
            
            <div className="login-form-group">
              <label htmlFor="password">
                <i className="fas fa-lock"></i>
                Password
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Inserisci la tua password"
                required
                disabled={loading}
              />
            </div>
            
            {error && (
              <div className="login-error-message">
                <i className="fas fa-exclamation-triangle"></i>
                {error}
              </div>
            )}
            
            <button type="submit" disabled={loading} className="login-button">
              {loading ? (
                <>
                  <div className="login-loading-spinner"></div>
                  Accesso in corso...
                </>
              ) : (
                <>
                  <i className="fas fa-sign-in-alt"></i>
                  Accedi
                </>
              )}
            </button>
          </form>
        </div>
      </div>
      
      <div className="login-footer">
        <p>© 2025 ScoutballItalia</p>
        <p>Tutti i diritti riservati</p>
      </div>
    </div>
  );
};

export default Login;